export default __webpack_public_path__ + "static/media/Favorite2.b288a41e.jpg";